
import { useState, useEffect, useCallback, useRef } from 'react';
import { generateUuid } from '@/utils/uuid';
import { hasClass } from './dom';
import { ICollectOptionListItem, IGenericObj, IGroupType, IObjNumber, IPageDataBoxType, IlistItem, IAnswerItem } from './ctype';




interface DustbinState {
	accepts: string[];
	lastDroppedItem: {data: ICollectOptionListItem; index: number; type: string;} | null;
  data: IlistItem;
  type: string;
  uid: string;
}

interface BoxState {
  data: ICollectOptionListItem;
	type: string;
  display: boolean;
  optionHidden: string;
  uid: string;
}

interface optionType<A, B> {
  optionHidden: string;
  type: A;
  accepts: [A, B];
  blankType: B;
  saveAnswerHandle: (index: number, value: IAnswerItem)=>void;
  pageData: IPageDataBoxType | undefined;
  loadAnswered: boolean;
  answerMap: IGenericObj<string[]>;
}


export function useDragAndDrop(data: IGroupType | undefined, option: optionType<string, string>) {

  const {list = [], collect_option, group_id, type: groupType} = (data || {}) as IGroupType;
  const { optionHidden, type: constType, accepts: constAccepts, blankType: constBlankType, saveAnswerHandle, loadAnswered, answerMap, pageData} = option; // optionHidden remove hidden no
  
  const uidRef = useRef<string>(generateUuid());



  useEffect(() => {
    if (list?.length && loadAnswered) {
      const listMap = collect_option.list.reduce((current:IObjNumber, item, index: number) => {
        current[item.id] = index;
        return current;
      }, {});
      let updated = false;
      list.forEach((itemData, index: number) => {
        const answer = answerMap[`${group_id}_${groupType}_${itemData.id}`];
        if (answer && answer[0]) {
          const answerIndex = listMap[answer[0]];
          updated = true;
          dustbins[index].lastDroppedItem = {data: collect_option.list[answerIndex], index: answerIndex, type: constType};
          boxes[answerIndex].display = false;
        }
      });
      if (updated) {
        setDustbins([...dustbins]);
      }
      
    }
  }, [pageData, loadAnswered, answerMap]);

  const [dustbins, setDustbins] = useState<DustbinState[]>(list.map((item) => ({
    accepts: constAccepts, lastDroppedItem: null, data: item, type: constBlankType, uid: uidRef.current
  })));

  

  const [boxes, setBoxes] = useState<BoxState[]>((collect_option?.list || []).map((item) => ({
    type: constType, display: true, data: item, optionHidden, uid: uidRef.current
  })));



  useEffect(() => {
    const keyDownHandle = function (event: any) {
      const {target} = event;
      if (hasClass(target, 'canDrag')) {
        const index = Number(target.dataset.index);
        const type = target.dataset.type;
        const did = target.dataset.did;
        let fIndex = -1;
        let optionData:{data: ICollectOptionListItem; index: number; type: string;} | null;

        const focusHandle = () => {
          setTimeout(() => {
            let focusEl:any = null;
            if (fIndex !== -1) {
              focusEl = document.querySelector(`[data-id="${constBlankType}_${dustbins[fIndex].data.id}"]`);
            } else {
              focusEl = document.querySelector(`[data-id="${constType}_${optionData && optionData.data.id}"]`);
            }
            if (focusEl) {
              (focusEl as any).focus();
            }
          }, 30);
        };

        const tabHandle = (order :boolean) => {
          if (did !== uidRef.current) {
            return false;
          }
          if (type === constType) {
            fIndex = (order ? dustbins.findIndex :dustbins.findLastIndex).call(dustbins, ((item, index) => {
              return !item.lastDroppedItem;
            }));
            optionData = {type: constType, data: boxes[index].data, index: index};
            if (fIndex !== -1) {
              boxes[index].display = false;
              setBoxes([...boxes]);
              dustbins[fIndex].lastDroppedItem = optionData;
              saveAnswerHandle(dustbins[fIndex].data.number, {group_id, type: groupType, id: dustbins[fIndex].data.id, answer: [String(dustbins[fIndex].lastDroppedItem!.data.id)]});
              
              setDustbins([...dustbins]);
            }
          } else if (type === constBlankType) {
            fIndex = (order ? dustbins.findIndex :dustbins.findLastIndex).call(dustbins,((item, itemIndex) => {
              return !item.lastDroppedItem && (order ? itemIndex > index : itemIndex < index) ;
            }));
            optionData = dustbins[index].lastDroppedItem;
            if (fIndex === - 1) {
              const optionIndex = dustbins[index]?.lastDroppedItem?.index;
              if (optionIndex !== undefined) {
                boxes[optionIndex].display = true;
                setBoxes([...boxes]);
              }
              
            }
            saveAnswerHandle(dustbins[index].data.number, {group_id, type: groupType, id: dustbins[index].data.id, answer: []});
            dustbins[index].lastDroppedItem = null;
            if (fIndex !== -1 ) {
              dustbins[fIndex].lastDroppedItem = optionData;
              saveAnswerHandle(dustbins[fIndex].data.number, {group_id, type: groupType, id: dustbins[fIndex].data.id, answer: [String(dustbins[fIndex].lastDroppedItem!.data.id)]});
            }
            setDustbins([...dustbins]);
          }
          return true;
        };
        let result = true;
        // 检查按下的键
        switch (event.key) {
          case 'ArrowUp':
          case 'ArrowLeft': 
            result = tabHandle(false);
            if (result) {
              focusHandle();
            }
            break;
          case 'ArrowDown':
          case 'ArrowRight':
            result = tabHandle(true);
            if (result) {
              focusHandle();

            }
            break;
          default:
          // 不处理其他按键
            break;
        }
      }
    };
    if (dustbins.length && boxes.length) {
      document.addEventListener('keydown', keyDownHandle);
    }
    
    return () => {
      if (dustbins.length && boxes.length) {
        document.removeEventListener('keydown', keyDownHandle);
      }
    };
  }, [dustbins, boxes]);


  const handleDrop = useCallback(
    (index: number, payItem: { data: ICollectOptionListItem | {type: string; index: number; data: ICollectOptionListItem;}; type: string; index: number; }) => {

      const { index: payIndex, type: payType} = payItem;
      // 在自己上面移动
      if (payType === constBlankType && payIndex === index) {
        return; 
      }

      const currentItem = dustbins[index];
      // 当前填空如果有选项，应该还原选项
      const { lastDroppedItem } = currentItem;
      if (lastDroppedItem) {
        const {data} = lastDroppedItem;
        // saveAnswerHandle(data.number, undefined);
        const lastIndex = lastDroppedItem?.index;
        boxes[lastIndex].display = true;
        setBoxes([...boxes]);
      }
      
      // 选项
      if (payType === constBlankType) {
        const lastItem = dustbins[payIndex];
        lastItem.lastDroppedItem = null;
        saveAnswerHandle(lastItem.data.number, {group_id, type: groupType, id: lastItem.data.id, answer: []});
        if (currentItem) {
          currentItem.lastDroppedItem = payItem.data as { data: ICollectOptionListItem; index: number; type: string; };

        }
      } else {
        currentItem.lastDroppedItem = payItem as { data: ICollectOptionListItem; index: number; type: string; };
        boxes[payIndex].display = false;
        setBoxes([...boxes]);
      }
      saveAnswerHandle(currentItem.data.number, {group_id, type: groupType, id: currentItem.data.id, answer: [String(currentItem.lastDroppedItem!.data.id)]});
      setDustbins([...dustbins]);
    },
    [boxes, dustbins],
  );

  const handleDropOptionList = useCallback((payItem: { data: {index: number; type: string; data: {data: IlistItem; index: number; type: string;} | IlistItem;}; type: string; index: number; }) => {
    const { index: payIndex, type: payType, data: payData} = payItem;
    if (payType === constBlankType) {
      const lastItem = dustbins[payIndex];
      lastItem.lastDroppedItem = null;
      setDustbins([...dustbins]);
      boxes[payData.index].display = true;
      setBoxes([...boxes]);
      saveAnswerHandle(dustbins[payIndex].data.number, {group_id, type: groupType, id: dustbins[payIndex].data.id, answer: []});
    }
  }, [boxes, dustbins]);

  const recoverOption = (index: number) => {
    boxes[index].display = true;
    setBoxes([...boxes]);
  };


  const recoverBlank= (index: number) => {
    saveAnswerHandle(dustbins[index].data.number, {group_id, type: groupType, id: dustbins[index].data.id, answer: []});
    dustbins[index].lastDroppedItem = null;
    setDustbins([...dustbins]);
  };

  return {
    dustbins,
    boxes,
    recoverOption,
    recoverBlank,
    handleDrop,
    handleDropOptionList,
    uid: uidRef.current
  };
}